import SpriteSymbol from "svg-baker-runtime/browser-symbol";
import sprite from "svg-sprite-loader/runtime/browser-sprite.build";
var symbol = new SpriteSymbol({
  "id": "icon-th-googleplaylogo",
  "use": "icon-th-googleplaylogo-usage",
  "viewBox": "0 0 32 32",
  "content": "<symbol xmlns=\"http://www.w3.org/2000/svg\" viewBox=\"0 0 32 32\" id=\"icon-th-googleplaylogo\">\n<path d=\"M27.9775 14.2737L7 2.26998C6.69419 2.09165 6.34651 1.99768 5.9925 1.99768C5.63849 1.99768 5.29082 2.09165 4.985 2.26998C4.6837 2.44275 4.43372 2.69247 4.26064 2.99359C4.08757 3.29472 3.99762 3.63642 4 3.98373V28.0162C3.99901 28.3632 4.09013 28.7042 4.26407 29.0044C4.438 29.3046 4.68851 29.5533 4.99 29.725C5.29582 29.9033 5.64349 29.9973 5.9975 29.9973C6.35151 29.9973 6.69919 29.9033 7.005 29.725L27.9775 17.725C28.287 17.5553 28.5451 17.3055 28.725 17.0018C28.9048 16.6981 28.9997 16.3517 28.9997 15.9987C28.9997 15.6458 28.9048 15.2993 28.725 14.9956C28.5451 14.6919 28.287 14.4422 27.9775 14.2725V14.2737ZM6 26.5837V5.41623L16.5863 16L6 26.5837ZM18 17.4137L20.365 19.7787L9.3025 26.1112L18 17.4137ZM9.3 5.88748L20.3662 12.2212L18 14.5862L9.3 5.88748ZM22.1637 18.75L19.4137 16L22.1637 13.25L26.9675 16L22.1637 18.75Z\" />\n</symbol>"
});
var result = sprite.add(symbol);
export default symbol


//////////////////
// WEBPACK FOOTER
// ./src/icons/svg/th-googleplaylogo.svg
// module id = zqen
// module chunks = 83